module.exports = __webpack_public_path__ + "static/media/NikolaosPapadakis-CV.5dd4c5be.pdf";